import { AppleIcon, DownloadAndroid, DownloadLinux, DownloadWindows } from '@/shared/constants/newDesignIcons';
import { appLinks } from '@/shared/constants/links';

const Link = {
  APPLE: 'https://apps.apple.com/app/id1643103017',
  WIN: 'https://www.microsoft.com/store/apps/9MSSGQT7GTC2',
  ANDROID: 'https://play.google.com/store/apps/details?id=musiconline.school',
};

export const config = {
  linux: {
    icon: DownloadLinux,
    path: appLinks.linux,
  },
  windows: {
    icon: DownloadWindows,
    path: Link.WIN,
  },
  apple: {
    icon: AppleIcon,
    path: Link.APPLE,
  },
  android: {
    icon: DownloadAndroid,
    path: Link.ANDROID,
  },
};